import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";

/**
 * Cart footer to use with conjunction of cart rows
 */
var CartFooter = function CartFooter(_ref) {
  var subtotalPrice = _ref.subtotalPrice,
      shippingPrice = _ref.shippingPrice,
      discountPrice = _ref.discountPrice,
      totalPrice = _ref.totalPrice;
  var intl = useIntl();
  return React.createElement(S.Wrapper, {
    showShipping: !!shippingPrice,
    showDiscount: !!discountPrice
  }, React.createElement(S.SubtotalText, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Subtotal",
    "id": "@next.components.atoms.CartFooter.CartFooter.781550514"
  }, "id", "@next.components.atoms.CartFooter.CartFooter.781550514"))), React.createElement(S.SubtotalPrice, null, subtotalPrice), shippingPrice && React.createElement(React.Fragment, null, React.createElement(S.ShippingText, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Shipping",
    "id": "@next.components.atoms.CartFooter.CartFooter.1325966144"
  }, "id", "@next.components.atoms.CartFooter.CartFooter.1325966144"))), React.createElement(S.ShippingPrice, null, shippingPrice)), discountPrice && React.createElement(React.Fragment, null, React.createElement(S.DiscountText, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Promo Code",
    "id": "@next.components.atoms.CartFooter.CartFooter.3639473373"
  }, "id", "@next.components.atoms.CartFooter.CartFooter.3639473373"))), React.createElement(S.DiscountPrice, null, discountPrice)), React.createElement(S.TotalText, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Total",
    "id": "@next.components.atoms.CartFooter.CartFooter.878013594"
  }, "id", "@next.components.atoms.CartFooter.CartFooter.878013594"))), React.createElement(S.TotalPrice, null, totalPrice));
};

export { CartFooter };